export default "__VITE_ASSET__CUjs05R7__"